import React, { useState, useEffect } from 'react'
import { RiFileExcel2Line } from 'react-icons/ri'
import { GrDocumentPdf } from 'react-icons/gr'
import { FaEye, FaTrash } from 'react-icons/fa'
import { ImArrowRight } from 'react-icons/im'
import { ImArrowLeft } from 'react-icons/im'
import styles from './Documents.module.css'
import {
  useGetClientOrderDocWithRetailMutation,
  useGetAllClientOrderDocsWithRetailMutation,
  useGetClientOrderDocPdfWithRetailMutation,
  useGetClientOrderDocXlsxWithRetailMutation,
  useGetClientOrderHistoryWithRetailQuery,
  useGetClientDataQuery,
} from '../../../redux/clientData/apiClientData'
import { useGetCurrencyRatesQuery } from '../../../redux/data/apiData'
import Loader from '../../loader/Loader'
import { DateTime } from 'luxon'

const Documents = ({ rerender }) => {
  const { data: ordersHistory, isLoading: isLoadingOrdersHistory } =
    useGetClientOrderHistoryWithRetailQuery()

  const { data: clientData } = useGetClientDataQuery()
  const { data: currencyRates } = useGetCurrencyRatesQuery()

  const [getOrderDoc, { isLoading: isLoadingOrderDoc }] =
    useGetClientOrderDocWithRetailMutation()

  const [getOrderDocPdf, { isLoading: isLoadingOrderDocPdf }] =
    useGetClientOrderDocPdfWithRetailMutation()

  const [getOrderDocXlsx, { isLoading: isLoadingOrderDocXlsx }] =
    useGetClientOrderDocXlsxWithRetailMutation()

  const [getAllOrderDocs, { isLoading: isLoadingAllOrderDocs }] =
    useGetAllClientOrderDocsWithRetailMutation()

  const [currentPage, setCurrentPage] = useState(1)
  const [isShowDoc, setIsShowDoc] = useState(false)
  const [docID, setDocID] = useState(null)
  const [docData, setDocData] = useState(null)
  const [docSum, setDocSum] = useState(0)

  const [isShowDetails, setIsShowDetails] = useState(false)
  const [isShowNegativeQty, setIsShowNegativeQty] = useState(false)
  const [detailedHistory, setDetailedHistory] = useState([])
  const [detailsCurrentPage, setDetailsCurrentPage] = useState(1)

  const [searchTerm, setSearchTerm] = useState('')
  const [detailsSearchTerm, setDetailsSearchTerm] = useState('')

  const [isCreateMode, setIsCreateMode] = useState(false)
  const [tempInvoice, setTempInvoice] = useState([])
  const [selectedItems, setSelectedItems] = useState({})
  const [allInvoicesData, setAllInvoicesData] = useState([])
  const [isViewTempInvoice, setIsViewTempInvoice] = useState(false)
  const [editingField, setEditingField] = useState(null)
  const [editingCreateModeField, setEditingCreateModeField] = useState(null)

  const [isUahMode, setIsUahMode] = useState(false)
  const [originalEuroPrices, setOriginalEuroPrices] = useState({})

  const emptyInvoiceMeta = {
    executor: '',
    carModel: '',
    carPlate: '',
    carVIN: '',
    carYearMileage: '',
  }
  const [invoiceMeta, setInvoiceMeta] = useState(emptyInvoiceMeta)

  const handleMetaChange = (field, value) => {
    setInvoiceMeta((prev) => ({ ...prev, [field]: value }))
  }

  const isEuroClient = clientData?.currency === 'eur'
  const eurRate = parseFloat(currencyRates?.eur) || 1

  const itemsPerPage = 10
  const sparesPerPage = 10

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  }

  const safeToString = (value) => (value != null ? value.toString() : '')

  useEffect(() => {
    setCurrentPage(1)
  }, [searchTerm])

  useEffect(() => {
    setDetailsCurrentPage(1)
  }, [detailsSearchTerm])

  useEffect(() => {
    if (isCreateMode && allInvoicesData.length > 0) {
      const createModeFilteredItems = allInvoicesData.filter((order) => {
        const searchString = detailsSearchTerm.toLowerCase()
        return (
          safeToString(order.docID).toLowerCase().includes(searchString) ||
          safeToString(order.brand).toLowerCase().includes(searchString) ||
          safeToString(order.spareCode).toLowerCase().includes(searchString) ||
          safeToString(order.description).toLowerCase().includes(searchString) ||
          safeToString(parseFloat(order.price).toFixed(2))
            .toLowerCase()
            .includes(searchString) ||
          safeToString(order.qty).toLowerCase().includes(searchString)
        )
      })
      const createModeTotalPages = Math.ceil(createModeFilteredItems.length / sparesPerPage)
      setDetailsCurrentPage((prevPage) => {
        if (createModeTotalPages === 0) {
          return 1
        }
        if (prevPage > createModeTotalPages) {
          return createModeTotalPages
        }
        return prevPage
      })
    }
  }, [isCreateMode, allInvoicesData, detailsSearchTerm])

  useEffect(() => {
    if (rerender) {
      setCurrentPage(1)
      setDetailsCurrentPage(1)
      setSearchTerm('')
      setDetailsSearchTerm('')
    }
  }, [rerender])


  useEffect(() => {
    if (!isViewTempInvoice) {
      setIsUahMode(false)
      setOriginalEuroPrices({})
    }
  }, [isViewTempInvoice])

  const filteredOrdersHistory = ordersHistory?.orderHistory.filter((order) =>
    Object.values(order).some((val) =>
      safeToString(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  )

  const totalItems = filteredOrdersHistory?.length || 0
  const totalPages = Math.ceil(totalItems / itemsPerPage)

  const lastItemIndex = currentPage * itemsPerPage
  const firstItemIndex = lastItemIndex - itemsPerPage
  const currentItems = filteredOrdersHistory?.slice(
    firstItemIndex,
    lastItemIndex
  )

  const filteredDetailedHistory = detailedHistory.filter((order) => {
  
    if (isShowNegativeQty && order.qty >= 0) {
      return false
    }
    
    const searchString = detailsSearchTerm.toLowerCase()
    return (
      safeToString(order.docID).toLowerCase().includes(searchString) ||
      safeToString(order.isExternalOrder ? 'Під замовлення' : 'Наявність')
        .toLowerCase()
        .includes(searchString) ||
      safeToString(order.brand).toLowerCase().includes(searchString) ||
      safeToString(order.spareCode).toLowerCase().includes(searchString) ||
      safeToString(order.description).toLowerCase().includes(searchString) ||
      safeToString(parseFloat(order.price).toFixed(2))
        .toLowerCase()
        .includes(searchString) ||
      safeToString(order.qty).toLowerCase().includes(searchString) ||
      safeToString((parseFloat(order.price) * order.qty).toFixed(2))
        .toLowerCase()
        .includes(searchString) ||
      safeToString(
        DateTime.fromJSDate(new Date(order.mvDate)).toFormat('dd.MM.yyyy')
      )
        .toLowerCase()
        .includes(searchString)
    )
  })

  const totalDetailsItems = filteredDetailedHistory.length
  const totalDetailsPages = Math.ceil(totalDetailsItems / sparesPerPage)

  const detailsLastItemIndex = detailsCurrentPage * sparesPerPage
  const detailsFirstItemIndex = detailsLastItemIndex - sparesPerPage
  const currentDetailsItems = filteredDetailedHistory.slice(
    detailsFirstItemIndex,
    detailsLastItemIndex
  )

  const goToNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages))
  }

  const goToPreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1))
  }

  const goToNextDetailsPage = () => {
    setDetailsCurrentPage((prevPage) =>
      Math.min(prevPage + 1, totalDetailsPages)
    )
  }

  const goToPreviousDetailsPage = () => {
    setDetailsCurrentPage((prevPage) => Math.max(prevPage - 1, 1))
  }

  const handleShowOrderDoc = async (docID) => {
    const orderDoc = await getOrderDoc({ docID })
    setDocData(orderDoc.data)
    setDocID(docID)
    const calculatedSum = orderDoc.data?.orderDoc?.reduce((sum, item) => {
      return sum + parseFloat(item.price) * item.qty
    }, 0) || 0
    setDocSum(calculatedSum.toFixed(2))
    setIsShowDoc(true)
  }

  const handleReturn = () => {
    setDocData(null)
    setDocID(null)
    setDocSum(0)
    setIsShowDoc(false)
  }

  const handleExportPdf = async (docID) => {
    try {
      if (docID === 'temp') {
        const items = tempInvoice.map((item) => ({
          spareCode: item.spareCode || '',
          brand: item.brand || '',
          qty: parseFloat(item.qty) || 0,
          price: parseFloat(item.price) || 0,
          sum: (parseFloat(item.price) || 0) * (parseFloat(item.qty) || 0),
          description: item.description || '',
          isExternalOrder: item.isExternalOrder !== undefined ? item.isExternalOrder : false,
        }))
        await getOrderDocPdf({ docID: null, items, meta: invoiceMeta })
      } else {
        await getOrderDocPdf({ docID })
      }
    } catch (error) {
    }
  }

  const handleExportXlsx = async (docID) => {
    try {
      if (docID === 'temp') {
        const items = tempInvoice.map((item) => ({
          spareCode: item.spareCode || '',
          brand: item.brand || '',
          qty: parseFloat(item.qty) || 0,
          price: parseFloat(item.price) || 0,
          sum: (parseFloat(item.price) || 0) * (parseFloat(item.qty) || 0),
          description: item.description || '',
          isExternalOrder: item.isExternalOrder !== undefined ? item.isExternalOrder : false,
        }))
        await getOrderDocXlsx({ docID: null, items, meta: invoiceMeta })
      } else {
        await getOrderDocXlsx({ docID })
      }
    } catch (error) {
    }
  }

  const handleShowDetailedHistory = async () => {
    if (!isShowDetails) {
      const allDocsResult = await getAllOrderDocs()
      const detailedHistoryData = allDocsResult.data.orderDocs
        .flatMap((doc) =>
          doc.orderDoc.map((item) => ({
            ...item,
            docID: doc.docID,
          }))
        )
        .sort((a, b) => {
          return new Date(b.mvDate) - new Date(a.mvDate)
        })
      setDetailedHistory(detailedHistoryData)
      setDetailsCurrentPage(1)
    } else {
      setDetailedHistory([])
    }
    setIsShowDetails(!isShowDetails)
    setIsShowNegativeQty(false) 
  }

  const handleShowNegativeQtyHistory = async () => {
    if (!isShowNegativeQty) {
      const allDocsResult = await getAllOrderDocs()
      const detailedHistoryData = allDocsResult.data.orderDocs
        .flatMap((doc) =>
          doc.orderDoc.map((item) => ({
            ...item,
            docID: doc.docID,
          }))
        )
        .sort((a, b) => {
          return new Date(b.mvDate) - new Date(a.mvDate)
        })
      setDetailedHistory(detailedHistoryData)
      setDetailsCurrentPage(1)
    } else {
      setDetailedHistory([])
    }
    setIsShowNegativeQty(!isShowNegativeQty)
    setIsShowDetails(false) 
  }

  const handleCreateInvoiceMode = async () => {
    if (!isCreateMode) {
      const allDocsResult = await getAllOrderDocs()
      const allItems = allDocsResult.data.orderDocs
        .flatMap((doc) =>
          doc.orderDoc.map((item) => ({
            ...item,
            docID: doc.docID,
            itemKey: `${doc.docID}_${item.spareCode}_${item.brand}`,
          }))
        )
        .filter((item) => item.qty > 0)
        .sort((a, b) => {
          return new Date(b.mvDate) - new Date(a.mvDate)
        })
      setAllInvoicesData(allItems)
      setSelectedItems({})
      setEditingCreateModeField(null)
    } else {
      setAllInvoicesData([])
      setSelectedItems({})
      setEditingCreateModeField(null)
    }
    setIsCreateMode(!isCreateMode)
    setIsShowDetails(false)
    setIsShowNegativeQty(false)
    setIsViewTempInvoice(false)
  }

  const handleToggleItemSelection = (item) => {
    const itemKey = item.itemKey
    if (selectedItems[itemKey]) {
      const newSelected = { ...selectedItems }
      delete newSelected[itemKey]
      setSelectedItems(newSelected)
    } else {
      const existingInInvoice = tempInvoice.find(invItem => invItem.itemKey === itemKey)
      
      const initialQty = existingInInvoice ? existingInInvoice.qty : item.qty
      const initialPrice = existingInInvoice ? parseFloat(existingInInvoice.price) : parseFloat(item.price)
      
      setSelectedItems({
        ...selectedItems,
        [itemKey]: {
          ...item,
          qty: Math.max(1, parseFloat(initialQty) || 1),
          price: Math.max(0.01, parseFloat(initialPrice) || 0.01),
        },
      })
    }
  }

  const handleUpdateSelectedItemQty = (itemKey, newQty, validate = false) => {
    let qty = newQty
    if (validate) {
      qty = Math.max(1, Math.min(1000, parseFloat(newQty) || 1))
    }
    if (selectedItems[itemKey]) {
      setSelectedItems({
        ...selectedItems,
        [itemKey]: {
          ...selectedItems[itemKey],
          qty: qty,
        },
      })
    }
  }

  const handleUpdateSelectedItemPrice = (itemKey, newPrice, validate = false) => {
    let price = newPrice
    if (validate) {
      const normalizedPrice = String(newPrice).replace(',', '.')
      price = Math.max(0.01, parseFloat(normalizedPrice) || 0.01)
    }
    if (selectedItems[itemKey]) {
      setSelectedItems({
        ...selectedItems,
        [itemKey]: {
          ...selectedItems[itemKey],
          price: price,
        },
      })
    }
  }

  const handleAddToTempInvoice = () => {
    const newItems = Object.values(selectedItems)
      .filter(item => {
        const normalizedPrice = String(item.price).replace(',', '.')
        const price = parseFloat(normalizedPrice) || 0
        const qty = parseFloat(item.qty) || 0
        return price > 0 && qty > 0
      })
      .map((item) => {
        const normalizedPrice = String(item.price).replace(',', '.')
        return {
          ...item,
          price: Math.max(0.01, parseFloat(normalizedPrice) || 0.01),
          qty: Math.max(1, parseFloat(item.qty) || 1),
        }
      })
    
    const updatedInvoice = [...tempInvoice]
    
    newItems.forEach(newItem => {
      const existingIndex = updatedInvoice.findIndex(item => item.itemKey === newItem.itemKey)
      if (existingIndex >= 0) {
        updatedInvoice[existingIndex] = newItem
      } else {
        updatedInvoice.push(newItem)
      }
    })
    
    setTempInvoice(updatedInvoice)
    setSelectedItems({})
  }

  const handleViewTempInvoice = () => {
    setIsViewTempInvoice(true)
    setIsCreateMode(false)
    setIsShowDetails(false)
    setIsShowNegativeQty(false)
  }

  const handleUpdateTempInvoiceQty = (index, newQty, validate = false) => {
    let qty = newQty
    if (validate) {
      qty = Math.max(1, Math.min(1000, parseFloat(newQty) || 1))
    }
    const updated = [...tempInvoice]
    updated[index] = {
      ...updated[index],
      qty: qty,
    }
    setTempInvoice(updated)
  }

  const handleUpdateTempInvoicePrice = (index, newPrice, validate = false) => {
    let price = newPrice
    if (validate) {
      const normalizedPrice = String(newPrice).replace(',', '.')
      price = Math.max(0.01, parseFloat(normalizedPrice) || 0.01)
    }
    const updated = [...tempInvoice]
    updated[index] = {
      ...updated[index],
      price: price,
    }
    setTempInvoice(updated)
    
  
    if (isUahMode && isEuroClient && validate) {
      const normalizedPrice = String(newPrice).replace(',', '.')
      const uahPrice = parseFloat(normalizedPrice) || 0.01
      const euroPrice = uahPrice / eurRate
      setOriginalEuroPrices({
        ...originalEuroPrices,
        [index]: euroPrice,
      })
    }
  }

  const handleToggleCurrency = () => {
    if (!isEuroClient || !eurRate) return

    if (!isUahMode) {
    
      const euroPrices = {}
      const updatedInvoice = tempInvoice.map((item, index) => {
        const euroPrice = parseFloat(item.price) || 0
        euroPrices[index] = euroPrice
        const uahPrice = euroPrice * eurRate
        return {
          ...item,
          price: uahPrice,
        }
      })
      setOriginalEuroPrices(euroPrices)
      setTempInvoice(updatedInvoice)
      setIsUahMode(true)
    } else {
 
      const updatedInvoice = tempInvoice.map((item, index) => {
        const uahPrice = parseFloat(item.price) || 0
        const euroPrice = uahPrice / eurRate
        return {
          ...item,
          price: euroPrice,
        }
      })
      setTempInvoice(updatedInvoice)
      setOriginalEuroPrices({})
      setIsUahMode(false)
    }
  }

  const handleStartEditing = (index, field) => {
    setEditingField({ index, field })
  }

  const handleStopEditing = () => {
    setEditingField(null)
  }

  const handleStartEditingCreateMode = (itemKey, field) => {
    setEditingCreateModeField({ itemKey, field })
  }

  const handleStopEditingCreateMode = () => {
    setEditingCreateModeField(null)
  }

  const handleDeleteTempInvoiceItem = (index) => {
    const updated = tempInvoice.filter((_, i) => i !== index)
    setTempInvoice(updated)
  }

  const calculateTempInvoiceSum = () => {
    return tempInvoice.reduce((sum, item) => {
      return sum + parseFloat(item.price || 0) * (item.qty || 0)
    }, 0)
  }

  const getSourceDisplay = (order) => {
    if (order.qty < 0) {
      return '—'
    }
    return order.isExternalOrder ? 'Під замовлення' : 'Наявність'
  }

  const highlightText = (text, highlight) => {
    if (!highlight.trim()) {
      return text
    }
    const escapedHighlight = escapeRegExp(highlight)
    const regex = new RegExp(`(${escapedHighlight})`, 'gi')
    return safeToString(text)
      .split(regex)
      .map((part, i) =>
        regex.test(part) ? (
          <span key={i} style={{ backgroundColor: 'yellow' }}>
            {part}
          </span>
        ) : (
          part
        )
      )
  }

  if (
    isLoadingOrdersHistory ||
    isLoadingOrderDoc ||
    isLoadingOrderDocPdf ||
    isLoadingOrderDocXlsx ||
    isLoadingAllOrderDocs
  )
    return <Loader />

  if (isViewTempInvoice) {
    return (
      <div className={styles.documentsContainer}>
        <div className={styles.documentsHeader}>
          <div>Тимчасова накладна</div>
        </div>
        <div className={styles.returnContainer}>
          <button 
            onClick={() => {
              setIsViewTempInvoice(false)
              setIsCreateMode(false)
              setEditingField(null)
              setIsUahMode(false)
              setOriginalEuroPrices({})
              setInvoiceMeta(emptyInvoiceMeta)
            }}
            className={styles.returnBtn}
          >
            Назад
          </button>
          {isEuroClient && (
            <label style={{ marginLeft: '20px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={isUahMode}
                onChange={handleToggleCurrency}
                style={{ cursor: 'pointer' }}
              />
              <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                Конвертувати в гривну
              </span>
            </label>
          )}
          <button
            onClick={() => handleExportPdf('temp')}
            className={styles.exportPdfBtn}
            style={{ marginLeft: '10px', fontSize: '22px' }}
            title="Експорт PDF"
          >
            <GrDocumentPdf />
          </button>
          <button
            onClick={() => handleExportXlsx('temp')}
            className={styles.exportExcelBtn}
            style={{ marginLeft: '10px', fontSize: '22px' }}
            title="Експорт Excel"
          >
            <RiFileExcel2Line />
          </button>
        </div>
        {tempInvoice.length === 0 ? (
          <div className={styles.noOrderHistory}>
            <p>Тимчасова накладна порожня...</p>
          </div>
        ) : (
          <>
            <div className={styles.metaForm}>
              <div className={styles.metaField}>
                <label htmlFor="meta-executor">Виконавець (ФОП / сервіс)</label>
                <input
                  id="meta-executor"
                  type="text"
                  className={styles.metaInput}
                  value={invoiceMeta.executor}
                  onChange={(e) => handleMetaChange('executor', e.target.value)}
                  placeholder="ФОП або назва сервісу"
                />
              </div>
              <div className={styles.metaField}>
                <label htmlFor="meta-car-model">Марка/модель</label>
                <input
                  id="meta-car-model"
                  type="text"
                  className={styles.metaInput}
                  value={invoiceMeta.carModel}
                  onChange={(e) => handleMetaChange('carModel', e.target.value)}
                  placeholder="Напр. Skoda Octavia"
                />
              </div>
              <div className={styles.metaField}>
                <label htmlFor="meta-car-plate">Держ. номер</label>
                <input
                  id="meta-car-plate"
                  type="text"
                  className={styles.metaInput}
                  value={invoiceMeta.carPlate}
                  onChange={(e) => handleMetaChange('carPlate', e.target.value)}
                  placeholder="Напр. AA1234BB"
                />
              </div>
              <div className={styles.metaField}>
                <label htmlFor="meta-car-vin">VIN</label>
                <input
                  id="meta-car-vin"
                  type="text"
                  className={styles.metaInput}
                  value={invoiceMeta.carVIN}
                  onChange={(e) => handleMetaChange('carVIN', e.target.value)}
                  placeholder="VIN-код"
                />
              </div>
              <div className={styles.metaField}>
                <label htmlFor="meta-car-year">Рік / пробіг</label>
                <input
                  id="meta-car-year"
                  type="text"
                  className={styles.metaInput}
                  value={invoiceMeta.carYearMileage}
                  onChange={(e) => handleMetaChange('carYearMileage', e.target.value)}
                  placeholder="Напр. 2018 / 120000 км"
                />
              </div>
            </div>
            <table className={styles.historyOrderTable}>
              <thead>
                <tr>
                  <th>Звідки</th>
                  <th>Бренд</th>
                  <th>Номер</th>
                  <th>Опис</th>
                  <th>Ціна</th>
                  <th>Кількість</th>
                  <th>Сума</th>
                  <th>Видалити</th>
                </tr>
              </thead>
              <tbody>
                {tempInvoice.map((spare, i) => {
                  const isEditingPrice = editingField?.index === i && editingField?.field === 'price'
                  const isEditingQty = editingField?.index === i && editingField?.field === 'qty'
                  
                  return (
                    <tr key={i}>
                      <td>{getSourceDisplay(spare)}</td>
                      <td>{spare.brand}</td>
                      <td>{spare.spareCode}</td>
                      <td>{spare.description}</td>
                      <td>
                        {isEditingPrice ? (
                          <input
                            type="text"
                            value={spare.price === undefined || spare.price === null ? '' : spare.price}
                            onChange={(e) => {
                       
                              const value = e.target.value.replace(/[^0-9.,-]/g, '')
                              handleUpdateTempInvoicePrice(i, value, false)
                            }}
                            onBlur={(e) => {
                              const normalizedValue = String(e.target.value).replace(',', '.')
                              const val = Math.max(0.01, parseFloat(normalizedValue) || 0.01)
                              handleUpdateTempInvoicePrice(i, val, true)
                              handleStopEditing()
                            }}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                const normalizedValue = String(e.target.value).replace(',', '.')
                                const val = Math.max(0.01, parseFloat(normalizedValue) || 0.01)
                                handleUpdateTempInvoicePrice(i, val, true)
                                handleStopEditing()
                                e.target.blur()
                              }
                              if (e.key === 'Escape') {
                                handleStopEditing()
                                e.target.blur()
                              }
                            }}
                            className={styles.editableInput}
                            autoFocus
                          />
                        ) : (
                          <span
                            onClick={() => handleStartEditing(i, 'price')}
                            className={styles.editableCell}
                            title="Натисніть для редагування"
                          >
                            {parseFloat(spare.price || 0).toFixed(2)}
                          </span>
                        )}
                      </td>
                      <td>
                        {isEditingQty ? (
                          <input
                            type="number"
                            value={spare.qty === undefined || spare.qty === null ? '' : spare.qty}
                            onChange={(e) => handleUpdateTempInvoiceQty(i, e.target.value, false)}
                            onBlur={(e) => {
                              const val = Math.max(1, Math.min(1000, parseFloat(e.target.value) || 1))
                              handleUpdateTempInvoiceQty(i, val, true)
                              handleStopEditing()
                            }}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                const val = Math.max(1, Math.min(1000, parseFloat(e.target.value) || 1))
                                handleUpdateTempInvoiceQty(i, val, true)
                                handleStopEditing()
                                e.target.blur()
                              }
                              if (e.key === 'Escape') {
                                handleStopEditing()
                                e.target.blur()
                              }
                            }}
                            className={styles.editableInput}
                            max="1000"
                            autoFocus
                          />
                        ) : (
                          <span
                            onClick={() => handleStartEditing(i, 'qty')}
                            className={styles.editableCell}
                            title="Натисніть для редагування"
                          >
                            {spare.qty || 0}
                          </span>
                        )}
                      </td>
                      <td>
                        {(parseFloat(spare.price || 0) * (spare.qty || 0)).toFixed(2)}
                      </td>
                      <td>
                        <button
                          onClick={() => handleDeleteTempInvoiceItem(i)}
                          className={styles.deleteBtn}
                          title="Видалити позицію"
                        >
                          <FaTrash />
                        </button>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <hr className={styles.modalHR} />
            <div className={styles.docSumContainer}>
              Всього: {calculateTempInvoiceSum().toFixed(2)}
            </div>
          </>
        )}
      </div>
    )
  }

  if (isCreateMode) {
    const createModeFilteredItems = allInvoicesData.filter((order) => {
      const searchString = detailsSearchTerm.toLowerCase()
      return (
        safeToString(order.docID).toLowerCase().includes(searchString) ||
        safeToString(order.brand).toLowerCase().includes(searchString) ||
        safeToString(order.spareCode).toLowerCase().includes(searchString) ||
        safeToString(order.description).toLowerCase().includes(searchString) ||
        safeToString(parseFloat(order.price).toFixed(2))
          .toLowerCase()
          .includes(searchString) ||
        safeToString(order.qty).toLowerCase().includes(searchString)
      )
    })

    const createModeTotalItems = createModeFilteredItems.length
    const createModeTotalPages = Math.ceil(createModeTotalItems / sparesPerPage)
    const createModeLastItemIndex = detailsCurrentPage * sparesPerPage
    const createModeFirstItemIndex = createModeLastItemIndex - sparesPerPage
    const createModeCurrentItems = createModeFilteredItems.slice(
      createModeFirstItemIndex,
      createModeLastItemIndex
    )

    const goToNextCreateModePage = () => {
      setDetailsCurrentPage((prevPage) =>
        Math.min(prevPage + 1, createModeTotalPages)
      )
    }

    const goToPreviousCreateModePage = () => {
      setDetailsCurrentPage((prevPage) => Math.max(prevPage - 1, 1))
    }

    return (
      <div className={styles.documentsContainer}>
        <div className={styles.documentsHeader}>
          <div>Створення накладної</div>
        </div>
        <div className={styles.toolBarContainer}>
          <span className={styles.showDetailsTextContainer}>Пошук:</span>
          <input
            type="text"
            placeholder=""
            value={detailsSearchTerm}
            onChange={(e) => setDetailsSearchTerm(e.target.value)}
            className={styles.searchInput}
          />
          <button
            onClick={handleAddToTempInvoice}
            className={styles.createInvoiceBtn}
            disabled={Object.keys(selectedItems).length === 0}
          >
            Додати до накладної
          </button>
          <button
            onClick={handleViewTempInvoice}
            className={styles.viewTempInvoiceBtn}
            disabled={tempInvoice.length === 0}
          >
            Переглянути тимчасову накладну
          </button>
          <button
            onClick={handleCreateInvoiceMode}
            className={styles.cancelCreateBtn}
          >
            Скасувати
          </button>
        </div>
        <hr className={styles.modalHrTop} />

        {createModeCurrentItems.length === 0 ? (
          <div className={styles.noResults}>Пошук не дав результатів...</div>
        ) : (
          <>
            <table className={styles.historyOrderTable}>
              <thead>
                <tr>
                  <th>Вибір</th>
                  <th>№ Накладної</th>
                  <th>Звідки</th>
                  <th>Бренд</th>
                  <th>Номер</th>
                  <th>Опис</th>
                  <th>Ціна</th>
                  <th>Кількість</th>
                  <th>Нова ціна</th>
                  <th>Нова кількість</th>
                </tr>
              </thead>
              <tbody>
                {createModeCurrentItems.map((order, i) => {
                  const isSelected = !!selectedItems[order.itemKey]
                  const selectedItem = selectedItems[order.itemKey]
                  const isInInvoice = tempInvoice.some(invItem => invItem.itemKey === order.itemKey)
                  return (
                    <tr key={i} style={isInInvoice ? { backgroundColor: 'rgba(0, 102, 153, 0.1)' } : {}}>
                      <td>
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => handleToggleItemSelection(order)}
                        />
                      </td>
                      <td>{highlightText(order.docID, detailsSearchTerm)}</td>
                      <td>{highlightText(getSourceDisplay(order), detailsSearchTerm)}</td>
                      <td>{highlightText(order.brand, detailsSearchTerm)}</td>
                      <td>{highlightText(order.spareCode, detailsSearchTerm)}</td>
                      <td>{highlightText(order.description, detailsSearchTerm)}</td>
                      <td>{highlightText(parseFloat(order.price).toFixed(2), detailsSearchTerm)}</td>
                      <td>{highlightText(order.qty, detailsSearchTerm)}</td>
                      <td>
                        {isSelected ? (
                          editingCreateModeField?.itemKey === order.itemKey && editingCreateModeField?.field === 'price' ? (
                            <input
                              type="text"
                              value={selectedItem.price === undefined || selectedItem.price === null ? '' : selectedItem.price}
                              onChange={(e) => {
                                const value = e.target.value.replace(/[^0-9.,-]/g, '')
                                handleUpdateSelectedItemPrice(order.itemKey, value, false)
                              }}
                              onBlur={(e) => {
                                const normalizedValue = String(e.target.value).replace(',', '.')
                                const val = Math.max(0.01, parseFloat(normalizedValue) || 0.01)
                                handleUpdateSelectedItemPrice(order.itemKey, val, true)
                                handleStopEditingCreateMode()
                              }}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  const normalizedValue = String(e.target.value).replace(',', '.')
                                  const val = Math.max(0.01, parseFloat(normalizedValue) || 0.01)
                                  handleUpdateSelectedItemPrice(order.itemKey, val, true)
                                  handleStopEditingCreateMode()
                                  e.target.blur()
                                }
                                if (e.key === 'Escape') {
                                  handleStopEditingCreateMode()
                                  e.target.blur()
                                }
                              }}
                              className={styles.editableInput}
                              autoFocus
                            />
                          ) : (
                            <span
                              onClick={() => handleStartEditingCreateMode(order.itemKey, 'price')}
                              className={styles.editableCell}
                              title="Натисніть для редагування"
                            >
                              {highlightText(parseFloat(selectedItem.price ?? order.price).toFixed(2), detailsSearchTerm)}
                            </span>
                          )
                        ) : (
                          '—'
                        )}
                      </td>
                      <td>
                        {isSelected ? (
                          editingCreateModeField?.itemKey === order.itemKey && editingCreateModeField?.field === 'qty' ? (
                            <input
                              type="number"
                              value={selectedItem.qty === undefined || selectedItem.qty === null ? '' : selectedItem.qty}
                              onChange={(e) =>
                                handleUpdateSelectedItemQty(order.itemKey, e.target.value, false)
                              }
                              onBlur={(e) => {
                                const val = Math.max(1, Math.min(1000, parseFloat(e.target.value) || 1))
                                handleUpdateSelectedItemQty(order.itemKey, val, true)
                                handleStopEditingCreateMode()
                              }}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  const val = Math.max(1, Math.min(1000, parseFloat(e.target.value) || 1))
                                  handleUpdateSelectedItemQty(order.itemKey, val, true)
                                  handleStopEditingCreateMode()
                                  e.target.blur()
                                }
                                if (e.key === 'Escape') {
                                  handleStopEditingCreateMode()
                                  e.target.blur()
                                }
                              }}
                              className={styles.editableInput}
                              max="1000"
                              autoFocus
                            />
                          ) : (
                            <span
                              onClick={() => handleStartEditingCreateMode(order.itemKey, 'qty')}
                              className={styles.editableCell}
                              title="Натисніть для редагування"
                            >
                              {highlightText(String(selectedItem.qty ?? order.qty), detailsSearchTerm)}
                            </span>
                          )
                        ) : (
                          '—'
                        )}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <hr className={styles.modalHR} />
            <div className={styles.infoBtnContainer}>
              <button
                disabled={detailsCurrentPage === 1}
                onClick={goToPreviousCreateModePage}
                className={styles.arrowBtn}
              >
                <ImArrowLeft />
              </button>
              {detailsCurrentPage} з {createModeTotalPages}
              <button
                disabled={detailsCurrentPage === createModeTotalPages || createModeTotalPages === 0}
                onClick={goToNextCreateModePage}
                className={styles.arrowBtn}
              >
                <ImArrowRight />
              </button>
            </div>
          </>
        )}
      </div>
    )
  }

  if (isShowDetails || isShowNegativeQty) {
    return (
      <div className={styles.documentsContainer}>
        <div className={styles.documentsHeader}>
          <div>
            {isShowNegativeQty 
              ? 'Історія покупок (повернення)' 
              : 'Історія покупок'
            }
          </div>
        </div>
        <div className={styles.toolBarContainer}>
          <span className={styles.showDetailsTextContainer}>Пошук:</span>
          <input
            type="text"
            placeholder=""
            value={detailsSearchTerm}
            onChange={(e) => setDetailsSearchTerm(e.target.value)}
            className={styles.searchInput}
          />
          <span className={styles.showDetailsTextContainer}>Розгорнути</span>
          <label className={styles.switch}>
            <input
              type="checkbox"
              checked={isShowDetails}
              onChange={handleShowDetailedHistory}
            />
            <span className={styles.slider}></span>
          </label>
          <span className={styles.showDetailsTextContainer}>Повернення</span>
          <label className={styles.switch}>
            <input
              type="checkbox"
              checked={isShowNegativeQty}
              onChange={handleShowNegativeQtyHistory}
            />
            <span className={styles.slider}></span>
          </label>
        </div>
        <hr className={styles.modalHrTop} />

        {currentDetailsItems.length === 0 ? (
          <div className={styles.noResults}>Пошук не дав результатів...</div>
        ) : (
          <>
            <table className={styles.historyOrderTable}>
              <thead>
                <tr>
                  <th>№ Накладної</th>
                  <th>Звідки</th>
                  <th>Бренд</th>
                  <th>Номер</th>
                  <th>Опис</th>
                  <th>Ціна</th>
                  <th>Кількість</th>
                  <th>Сума</th>
                  <th>Дата</th>
                </tr>
              </thead>
              <tbody>
                {currentDetailsItems?.map((order, i) => (
                  <tr key={i}>
                    <td>{highlightText(order.docID, detailsSearchTerm)}</td>
                    <td>
                      {highlightText(
                        getSourceDisplay(order),
                        detailsSearchTerm
                      )}
                    </td>
                    <td>{highlightText(order.brand, detailsSearchTerm)}</td>
                    <td>
                      {highlightText(order.spareCode, detailsSearchTerm)}
                    </td>
                    <td>
                      {highlightText(order.description, detailsSearchTerm)}
                    </td>
                    <td>
                      {highlightText(
                        parseFloat(order.price).toFixed(2),
                        detailsSearchTerm
                      )}
                    </td>
                    <td>{highlightText(order.qty, detailsSearchTerm)}</td>
                    <td>
                      {highlightText(
                        (parseFloat(order.price) * order.qty).toFixed(2),
                        detailsSearchTerm
                      )}
                    </td>
                    <td>
                      {highlightText(
                        DateTime.fromJSDate(new Date(order.mvDate)).toFormat(
                          'dd.MM.yyyy'
                        ),
                        detailsSearchTerm
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <hr className={styles.modalHR} />
            <div className={styles.infoBtnContainer}>
              <button
                disabled={detailsCurrentPage === 1}
                onClick={goToPreviousDetailsPage}
                className={styles.arrowBtn}
              >
                <ImArrowLeft />
              </button>
              {detailsCurrentPage} з {totalDetailsPages}
              <button
                disabled={detailsCurrentPage === totalDetailsPages}
                onClick={goToNextDetailsPage}
                className={styles.arrowBtn}
              >
                <ImArrowRight />
              </button>
            </div>
          </>
        )}
      </div>
    )
  }

  if (isShowDoc)
    return (
      <div className={styles.documentsContainer}>
        <div className={styles.documentsHeader}>
          <div>Накладна № {docID}</div>
        </div>
        <div className={styles.returnContainer}>
          <button onClick={handleReturn} className={styles.returnBtn}>
            Назад
          </button>
        </div>
        <table className={styles.historyOrderTable}>
          <thead>
            <tr>
              <th>Звідки</th>
              <th>Бренд</th>
              <th>Номер</th>
              <th>Опис</th>
              <th>Ціна</th>
              <th>Кількість</th>
              <th>Сума</th>
            </tr>
          </thead>
          <tbody>
            {docData?.orderDoc?.map((spare, i) => (
              <tr key={i}>
                <td>
                  {getSourceDisplay(spare)}
                </td>
                <td>{spare.brand}</td>
                <td>{spare.spareCode}</td>
                <td>{spare.description}</td>
                <td>{parseFloat(spare.price).toFixed(2)}</td>
                <td>{spare.qty}</td>
                <td>{(parseFloat(spare.price) * spare.qty).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <hr className={styles.modalHR} />
        <div className={styles.docSumContainer}>Всього: {docSum}</div>
      </div>
    )

  return (
    <div className={styles.documentsContainer}>
      <div className={styles.documentsHeader}>
        <div>Документи</div>
      </div>
      {ordersHistory?.orderHistory.length === 0 ? (
        <div className={styles.noOrderHistory}>
          <p>Історія покупок відсутня...</p>
        </div>
      ) : (
        <>
          <div className={styles.toolBarContainer}>
            <span className={styles.showDetailsTextContainer}>Пошук:</span>
            <input
              type="text"
              placeholder=""
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
            />
            <span className={styles.showDetailsTextContainer}>
              Розгорнути
            </span>
            <label className={styles.switch}>
              <input
                type="checkbox"
                checked={isShowDetails}
                onChange={handleShowDetailedHistory}
              />
              <span className={styles.slider}></span>
            </label>
            <span className={styles.showDetailsTextContainer}>Повернення</span>
            <label className={styles.switch}>
              <input
                type="checkbox"
                checked={isShowNegativeQty}
                onChange={handleShowNegativeQtyHistory}
              />
              <span className={styles.slider}></span>
            </label>
            <button
              onClick={handleCreateInvoiceMode}
              className={styles.createInvoiceBtn}
            >
              {tempInvoice.length > 0 ? 'Додати в накладну' : 'Створити накладну'}
            </button>
            <button
              onClick={handleViewTempInvoice}
              className={styles.viewTempInvoiceBtn}
              disabled={tempInvoice.length === 0}
            >
              Переглянути тимчасову накладну
            </button>
          </div>
          <hr className={styles.modalHrTop} />

          {currentItems.length === 0 ? (
            <div className={styles.noResults}>
              Пошук не дав результатів...
            </div>
          ) : (
            <>
              <table className={styles.historyOrderTable}>
                <thead>
                  <tr>
                    <th>№ Накладної</th>
                    <th>Сума</th>
                    <th>Переглянути</th>
                    <th>Експорт - pdf, xlsx</th>
                    <th>Дата відвантаження</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((order, i) => (
                    <tr key={i}>
                      <td>{highlightText(order.docID, searchTerm)}</td>
                      <td>{highlightText(order.sum, searchTerm)}</td>
                      <td>
                        <button
                          onClick={() =>
                            handleShowOrderDoc(order.docID)
                          }
                          className={styles.viewBtn}
                        >
                          <FaEye />
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() => handleExportPdf(order.docID)}
                          className={styles.exportPdfBtn}
                        >
                          <GrDocumentPdf />
                        </button>
                        <button
                          onClick={() => handleExportXlsx(order.docID)}
                          className={styles.exportExcelBtn}
                        >
                          <RiFileExcel2Line />
                        </button>
                      </td>
                      <td>{highlightText(order.sellDate, searchTerm)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <hr className={styles.modalHR} />
              <div className={styles.infoBtnContainer}>
                <button
                  disabled={currentPage === 1}
                  onClick={goToPreviousPage}
                  className={styles.arrowBtn}
                >
                  <ImArrowLeft />
                </button>
                {currentPage} з {totalPages}
                <button
                  disabled={currentPage === totalPages}
                  onClick={goToNextPage}
                  className={styles.arrowBtn}
                >
                  <ImArrowRight />
                </button>
              </div>
            </>
          )}
        </>
      )}
    </div>
  )
}

export default Documents

